<template>
  <div class="access-denied-page">
    <div class="access-denied-panel bg-white">
      <div class="access-denied-icon">
        <i class="ph ph-lock-key"></i>
      </div>

      <span class="access-denied-eyebrow">Acesso restrito</span>
      <h1 class="fw-bold text-black mb-12">
        Voce nao tem permissao para acessar {{ moduleName }}
      </h1>
      <p class="mb-0">
        Entre em contato com o administrador do sistema para solicitar acesso a este modulo.
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "AccessDeniedPage",
  computed: {
    moduleName(): string {
      const module = this.$route.query.module;

      return typeof module === "string" && module ? module : "este modulo";
    },
  },
});
</script>

<style scoped>
.access-denied-page {
  width: 100%;
  display: flex;
  min-height: 60vh;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.access-denied-panel {
  width: 100%;
  max-width: 560px;
  padding: 38px;
  text-align: center;
  border-radius: 8px;
  box-shadow: 0 10px 35px rgba(13, 12, 29, 0.08);
}

.access-denied-icon {
  width: 64px;
  height: 64px;
  display: inline-flex;
  color: var(--splash-primary-color);
  font-size: 32px;
  align-items: center;
  margin-bottom: 18px;
  border-radius: 50%;
  justify-content: center;
  background: #f5f4ff;
}

.access-denied-eyebrow {
  display: block;
  color: var(--splash-primary-color);
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 10px;
  text-transform: uppercase;
}

.access-denied-panel h1 {
  font-size: 28px;
  line-height: 1.2;
}

.access-denied-panel p {
  color: var(--splash-paragraph-color);
  font-size: 16px;
}

@media (max-width: 767px) {
  .access-denied-page {
    min-height: calc(100vh - 190px);
    padding: 16px;
  }

  .access-denied-panel {
    padding: 28px 20px;
  }

  .access-denied-panel h1 {
    font-size: 22px;
  }

  .access-denied-panel p {
    font-size: 14px;
  }
}
</style>
